module.exports = "https://images.shiksha.ws/saassets/media/Arrow-Teal.31cf10d9.png";